export default function getDocumentModalProps(documentNumber) {
  return {
    documentNumber: documentNumber,
    forceReadOnly: true,
  };
}
